import React from "react";
import DiscountIcon from "@/public/fallbacks/discount-transparent.svg";
import s from "@/components/ProductCards/ProductCard.module.scss";

const DiscountTagBlock = ({ discountAppliedLabel }) => {
  return (
    <p className={s["productCard__titleBlock--discountTagBlock"]}>
      <img className={s["productCard__titleBlock--discountTag"]} src={DiscountIcon} alt="Discount" />
      {discountAppliedLabel}
    </p>
  );
};

export default DiscountTagBlock;
